export class WAlertConstant {
  static confirm = "confirm";
  static cancelled = "cancelled";
  static successful = "successful";
  static warning = "warning";
  static question = "question";
  static cart = "cart";
}